var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VueUeditorWrap',{attrs:{"config":_vm.editorConfig},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }